"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomKey = exports.reportError = exports.reportInfo = exports.getXsrf = void 0;
// @ts-ignore
var steamer_browserutils_1 = require("steamer-browserutils");
var getXsrf = function () { return steamer_browserutils_1.getCookie('TOK'); };
exports.getXsrf = getXsrf;
var reportInfo = function (msg, data) {
    if (window.log && window.log.info) {
        window.log.info(msg, data);
    }
};
exports.reportInfo = reportInfo;
var reportError = function (msg, data) {
    if (window.log && window.log.error) {
        window.log.error(msg, data);
    }
};
exports.reportError = reportError;
// 获取一个随机id，避免多次引用组件时微信标签id重复
var getRandomKey = function () { return Date.now().toString(36) + "_" + (Math.floor(Math.random() * 1000) % 1000); };
exports.getRandomKey = getRandomKey;
